<template>
  <div>
    <s-table
      ref="table"
      size="default"
      :rowKey="record => record.id"
      :columns="columns"
      :data="loadData"
      showPagination="auto"
    >
      <span slot="completedAmount" slot-scope="text">{{ text | priceFilter }}</span>
      <span slot="amount" slot-scope="text">{{ text | priceFilter }}</span>
      <span slot="time" slot-scope="text">{{ text | textFilter }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="edit(record)">修改</a>
      </span>
    </s-table>
    <invoice-form ref="InvoiceForm" @reload="reload" />
  </div>
</template>

<script>
import { STable, Ellipsis } from '@/components'
import InvoiceForm from '../../invoice/components/InvoiceForm'
import { moxiInvoices } from '@/api/moxi'
import { invoiceColumns, financeInvoiceColumns } from '../js/index'
export default {
  props: {
    detailId: {
      type: String,
      default: ''
    }
  },
  components: {
    STable, 
    Ellipsis,
    InvoiceForm
  },
  created() {
    this.id = this.detailId || this.$route.query.id
  },
  data() {
    return {
      id: null,
      loadData: parameter => {
        return moxiInvoices(this.dingUserId, this.id).then(res => {
          if (res.success) {
            const result = this.dResDataFormat(res)
            return result
          }
        })
      }
    }
  },
  computed: {
    dingUserId() {
      return this.$store.state.dingUser.data.user_id
    },
    columns() {
      if (this.btnPermission('member_addition')) {
        return financeInvoiceColumns
      } else {
        return invoiceColumns
      }
    }
  },
  methods: {
    reload() {
      this.tableHome()
      this.$refs.table.refresh()
    },
    edit(record) {
      this.$refs.InvoiceForm.show(record)
    }
  }
}
</script>
